import { render, staticRenderFns } from "./V_Creator_Events_Item.vue?vue&type=template&id=67c7d980&scoped=true&"
import script from "./V_Creator_Events_Item.vue?vue&type=script&lang=js&"
export * from "./V_Creator_Events_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7d980",
  null
  
)

export default component.exports